import { motion } from "framer-motion";
import { FaCheckCircle } from "react-icons/fa";

const reasons = [
  {
    title: "Modern & Scalable Solutions",
    text: "We build systems using modern technologies that grow with your business."
  },
  {
    title: "Client-Focused Approach",
    text: "Every solution is tailored to your specific needs, goals, and challenges."
  },
  {
    title: "End-to-End Expertise",
    text: "From planning and design to development and support, we handle it all."
  },
  {
    title: "Empowerment Through Education",
    text: "Our academy ensures skills transfer, sustainability, and long-term value."
  }
];

export default function WhyUs() {
  return (
    <section className="why-us">
      <h2>Why Choose Us</h2>

      <div className="why-grid">
        {reasons.map((item, index) => (
          <motion.div
            key={index}
            className="why-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.15 }}
            viewport={{ once: true }}
          >
            <FaCheckCircle />
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
